export const ENTITY_TYPES_LOADED = 'ENTITY_TYPES_LOADED'; // eslint-disable-line
